import { makeStyles } from "tss-react/mui"

export const useStyles = makeStyles()(() => ({
  root: {
    position: "relative",

    "& img": {
      maxHeight: "200px",
      maxWidth: "300px"
    }
  }
}))
